@if (session.dialogVisible()) {
    <div class="yl-app" [attr.data-theme]="theme.theme()" [attr.data-palette]="theme.palette()">
        <div class="yl-dialog-backdrop yl-session-backdrop">
            <div class="yl-dialog yl-dialog--sm" role="dialog" aria-modal="true" aria-labelledby="yl-session-title">
                <div class="yl-dialog-header">
                    <h2 class="yl-dialog-title" id="yl-session-title">Session expired</h2>
                </div>

                <div class="yl-dialog-body yl-session-body">
                    @if (session.dialogMode() === 'refresh') {
                        <div class="yl-session-lead">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="var(--warn)"
                                stroke-width="1.9"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="9"></circle>
                                <path d="M12 7v5l3 2"></path>
                            </svg>
                            <p class="yl-dialog-copy">
                                Your session timed out. Refresh it to pick up right where you left off.
                            </p>
                        </div>
                    } @else {
                        <div class="yl-session-lead">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="var(--bad)"
                                stroke-width="1.9"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <rect x="4" y="10" width="16" height="11" rx="2"></rect>
                                <path d="M8 10V7a4 4 0 0 1 8 0v3"></path>
                            </svg>
                            <p class="yl-dialog-copy">Your session expired. Enter your password to continue.</p>
                        </div>

                        <label class="yl-form-label" for="yl-session-email">Email</label>
                        <input
                            id="yl-session-email"
                            class="yl-input"
                            type="text"
                            autocomplete="username"
                            [value]="session.sessionEmail()"
                            disabled />

                        <label class="yl-form-label" for="yl-session-password">Password</label>
                        <input
                            id="yl-session-password"
                            class="yl-input"
                            type="password"
                            autocomplete="current-password"
                            placeholder="Enter your password"
                            [(ngModel)]="password"
                            [disabled]="session.isProcessing()"
                            (keydown.enter)="onRelogin()" />
                    }

                    @if (session.errorMessage()) {
                        <p class="yl-field-error yl-session-error">{{ session.errorMessage() }}</p>
                    }
                </div>

                <div class="yl-dialog-actions yl-session-actions">
                    @if (session.dialogMode() === 'refresh') {
                        <button
                            type="button"
                            class="yl-btn yl-btn-primary yl-session-btn"
                            [disabled]="session.isProcessing()"
                            (click)="onRefresh()">
                            {{ session.isProcessing() ? 'Refreshing…' : 'Refresh session' }}
                        </button>
                    } @else {
                        <button
                            type="button"
                            class="yl-btn yl-btn-primary yl-session-btn"
                            [disabled]="!password.trim() || session.isProcessing()"
                            (click)="onRelogin()">
                            {{ session.isProcessing() ? 'Signing in…' : 'Sign in' }}
                        </button>
                    }
                    <button
                        type="button"
                        class="yl-btn yl-btn-text yl-session-btn"
                        [disabled]="session.isProcessing()"
                        (click)="onLogout()">
                        Log out
                    </button>
                </div>
            </div>
        </div>
    </div>
}
